import React, { useState, useEffect, useRef } from 'react';
import { Card } from './ui/card';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
// import { Upload } from 'antd';
import { debounce } from 'lodash';
import './homepage.css';
import type { UploadRequestOption } from 'rc-upload/lib/interface';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import {
  Play,
  Clock,
  MoreVertical,
  Trash2,
  Share2,
  Image as ImageIcon,
  ArrowRight,
  RefreshCw,
  X,
  Shuffle,
  Loader2,
  Paperclip,
  CircleAlert,
  FileText,
} from 'lucide-react';
import { toast } from 'sonner';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { MultiQuestionDialog } from './MultiQuestionDialog';
// import mathHomeworkImage from "figma:asset/9fc642a9ef887afd16174a8f81cbcd5416a134f9.png";
import {
  analyzeUserInput,
  cancelGenerate,
  cancelSolve,
  deleteMyVideo,
  getImgUploadSignInfo,
  getMyVideoList,
  getRecomVideoList,
  getVideoStatus,
} from '../api/home';
import { getFileTypeByFileName } from '../utils/ImgUtils';
// import { RcFile } from 'antd/es/upload';
import {
  IQuestion,
  IRecomendVideo,
  TVideoStatus,
  VideoCard,
} from '../model/home';
import { mySubjectColors, subjectColors } from '../consts/subject';
import { E_LocalStorageKey, LocalStorageUtil } from '../utils/LocalStorageUtil';
import { formatDuration, videoCardToCommon } from '../utils/VideoUtils';
import { Spinner } from '@radix-ui/themes';
import ShareDialog from './ShareDialog';
import { FloatingDecorations } from './FloatingDecorations';
import PlayBtn from './ui/PlayBtn';
import SubmitBtn from '../assets/submit-able.png';
import SubmitBtnDiabled from '../assets/submit-diabled.png';
import {
  getQuestionListFromLocal,
  setQuestionListToLocal,
} from '../utils/QuesUtil';
import { formatTimeAgo } from '../utils/DateUtils';
import RecommendedClipsGrid from './RecommendedClipsGrid';
import QuestionDeleteConfirmDialog from './QuestionDeleteConfirmDialog';
import { CandidatePrompt } from './homepage/CandidatePrompt';
import { MyVideoCard, SubjectColor } from './homepage/MyVideoCard';
import { useDynamicTypingPlaceholder } from '../../hooks/useDynamicTypingPlaceholder';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import { useSidebar } from './ui/sidebar';
import iconXplai from '../assets/icon-logo-xplai.png';
import { getExporeList } from '../api/expore';
import CircularProgress from './homepage/CircularProgress';
import { CommonVideoCard } from './homepage/CommonVideoCard';

interface Video {
  id: string;
  question: string;
  status: 'generating' | 'complete';
  thumbnail: string;
  createdAt: Date;
  subject:
    | 'Mathematics'
    | 'Physics'
    | 'Biology'
    | 'Chemistry'
    | 'History'
    | 'Geography'
    | 'Psychology'
    | 'Computer Science'
    | 'AI'
    | 'Economics'
    | 'Literature'
    | 'Engineering';
  progress: number;
  videoCount: number;
  isFavorite?: boolean;
  duration?: number;
  watchProgress?: number;
}

interface HomePageProps {
  onGenerate: (videos: VideoCard) => void;
  videos: Video[];
  userid: string | undefined | null;
  updateFlag: boolean;
  onVideoClick: (videoId: string) => void;
  onUpdateVideoStatus: (videoId: string, status: TVideoStatus) => void;
  onDeleteVideo: (videoId: string) => void;
  onToggleFavorite: (videoId: string) => void;
  onNavigateToExplore?: () => void;
  onNavigateToMyVideos?: () => void;
  isLoggedIn: boolean;
  onShowLogin: () => void;
  onReGenerate: (vid: string) => any;
  onCancelGenerate: (vid: string) => any;
  handleHasUpdated: () => void;
}

const progressStages = [
  'Analyzing your question...',
  'Generating video structure...',
  'Adding explanations and visuals...',
  'Finalizing your video!',
];

// const subjectColors: Record<Video["subject"], { bg: string; text: string }> = {
//   Mathematics: { bg: "bg-primary/20", text: "text-black" },
//   Physics: { bg: "bg-primary/20", text: "text-black" },
//   Biology: { bg: "bg-primary/20", text: "text-black" },
//   Chemistry: { bg: "bg-primary/20", text: "text-black" },
//   History: { bg: "bg-primary/20", text: "text-black" },
//   Geography: { bg: "bg-primary/20", text: "text-black" },
//   Psychology: { bg: "bg-primary/20", text: "text-black" },
//   "Computer Science": { bg: "bg-primary/20", text: "text-black" },
//   AI: { bg: "bg-primary/20", text: "text-black" },
//   Economics: { bg: "bg-primary/20", text: "text-black" },
//   Literature: { bg: "bg-primary/20", text: "text-black" },
//   Engineering: { bg: "bg-primary/20", text: "text-black" },
// };

type ProgressType = 'none' | 'init' | 'qproc_1' | 'qproc_2';
export function HomePage({
  onGenerate,
  videos,
  userid,
  updateFlag,
  onVideoClick,
  onUpdateVideoStatus,
  onDeleteVideo,
  onToggleFavorite,
  onNavigateToExplore,
  onNavigateToMyVideos,
  isLoggedIn,
  onShowLogin,
  onReGenerate,
  onCancelGenerate,
  handleHasUpdated,
}: HomePageProps) {
  const { state } = useSidebar();
  const [curtab, setCurtab] = useState<'my-videos' | 'queue' | 'example'>(
    'my-videos',
  );
  // 上传图片
  const [isUploading, setIsUploading] = useState(false);
  // 提交问题
  const [isSubmitQuestion, setIsSubmitQuestion] = useState(false);
  // 拆题进行中
  // const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [recommendVideos, setRecommendVideos] = useState<VideoCard[]>([]);
  const [picUrl, setPicUrl] = useState('');
  const videoStatusStRef = useRef<number | undefined>(void 0);
  const progressStRef = useRef<number | undefined>(void 0);
  const updateMyVideoListRef = useRef<number | undefined>(void 0);
  const [question, setQuestion] = useState('');
  const { displayText: typingPlaceholder, markUserHasTyped } =
    useDynamicTypingPlaceholder({
      placeholders: [
        'Ask Xplai to answer your question...',
        'Ask Xplai to explain your topic...',
        'Ask Xplai to solve a math problem...',
        'Ask Xplai to help you understand...',
        'Ask Xplai to break down a theory...',
      ],
    });
  const questionRef = useRef<string>('');
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [picSrc, setPicSrc] = useState<string>('');
  const [progressType, setProgressType] = useState<ProgressType>('none');
  const [progressValue, setProgressValue] = useState(100);
  const inputRef = useRef<HTMLTextAreaElement | null>(null);
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [isDragOver, setIsDragOver] = useState(false);

  const [showMultiQuestionDialog, setShowMultiQuestionDialog] = useState(false);
  const [detectedQuestions, setDetectedQuestions] = useState<Array<IQuestion>>(
    [],
  );
  const [questionImageUrl, setQuestionImageUrl] = useState<string | undefined>(
    undefined,
  );
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  // const [copied, setCopied] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteQuestionDialogOpen, setDeleteQuestionDialogOpen] =
    useState(false);
  const [videoToDelete, setVideoToDelete] = useState<string | null>(null);
  const [myVideoList, setMyVideoList] = useState<VideoCard[]>([]);
  const [isMyVideosLoading, setIsMyVideosLoading] = useState(false);
  // 追踪新生成的视频ID，用于触发左滑动画
  const [newVideoIds, setNewVideoIds] = useState<Set<string>>(new Set());
  const [isRecommendLoading, setIsRecommendLoading] = useState(true);
  // 拆题进行中
  const isAnalyzing = progressValue < 100;
  // console.log('progress:', progressValue);
  const lastShuffleIndexRef = useRef<number>(-1); // 记录上一次随机题目的索引
  const [waitLen, setWaitLen] = useState(0);
  const progressMap: {
    [K in ProgressType]: string;
  } = {
    none: '',
    init: 'Waiting in queue',
    qproc_1: 'Recognizing the problem',
    qproc_2: 'Working hard on it',
  };

  // 随机题目列表
  const shuffleQuestions = [
    'Why is dividing by zero undefined?',
    'What is the Fibonacci sequence and where does it appear in nature?',
    'How do negative numbers work in real life?',
    'Why is the sky blue?',
    'How do magnets work?',
    'What would happen if you traveled at the speed of light?',
    'Why does ice float on water?',
    'What makes fireworks different colors?',
    'Why do we need to sleep?',
    'How do vaccines work?',
    "Why can't humans breathe underwater like fish?",
    'What is a black hole?',
    'Why do we have seasons on Earth?',
    'Could humans live on Mars?',
    'What is inflation and why does it matter?',
    'How does compound interest work?',
    'Why are there different time zones?',
    'How do earthquakes happen?',
    'Why do we see lightning before we hear thunder?',
    'How does the internet actually work?',
  ];

  // 随机选择一道题目（避免连续重复）
  const handleShuffle = () => {
    let randomIndex: number;
    do {
      randomIndex = Math.floor(Math.random() * shuffleQuestions.length);
    } while (
      randomIndex === lastShuffleIndexRef.current &&
      shuffleQuestions.length > 1
    );

    lastShuffleIndexRef.current = randomIndex;
    // setQuestion(shuffleQuestions[randomIndex]);
    handleQuestionStr(shuffleQuestions[randomIndex]);
    // removeCurLocalStorageQuestion();
  };

  const handleQuestionStr = (str: string) => {
    setQuestion(str);
    questionRef.current = str;
  };

  // 候选提示词点击
  const handleCandidatePromptClick = (text: string) => {
    handleQuestionStr(text);
    inputRef.current?.focus();
  };

  useEffect(() => {
    (async () => {
      setCurtab('my-videos');
      // console.log(userid);
      if (userid) {
        try {
          // 只有第一次请求才loadding
          setIsMyVideosLoading(true);
          await updateMyVideoList();
          setIsMyVideosLoading(false);
          const videoId = LocalStorageUtil.getLocalStorage(
            E_LocalStorageKey.userCurGenerateQuestionId,
          );
          const picUrl = LocalStorageUtil.getLocalStorage(
            E_LocalStorageKey.userCurGenerateQuestionPicUrl,
          );
          // const questionContent = LocalStorageUtil.getLocalStorage(
          //   E_LocalStorageKey.userCurGenerateQuestionContent,
          // );
          // 恢复上次提问
          if (videoId) {
            handleUserInputQuestionStatus(videoId, picUrl);
            // if (picUrl) {
            //   setPicUrl(picUrl);
            // }
            // if (questionContent) {
            //   setQuestion(questionContent);
            // }
          }
        } catch (e) {
          toast.error(e.message || 'request failed');
          setIsMyVideosLoading(false);
        }
      } else {
        setCurtab('example');
        setMyVideoList([]);
        setIsMyVideosLoading(false);
      }
    })();
  }, [userid]);
  useEffect(() => {
    if (uploadFile) {
      const filereader = new FileReader();
      filereader.onload = (e) => {
        // console.log(e.target.result);
        setPicSrc(e.target.result as string);
      };
      filereader.readAsDataURL(uploadFile);
    } else {
      setPicSrc('');
    }
  }, [uploadFile]);
  useEffect(() => {
    document.addEventListener('keydown', function (event) {
      // 禁用 Ctrl+Enter
      // console.log(event.key, event.ctrlKey);
      if (event.ctrlKey && ['enter'].includes(event.key.toLowerCase())) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    });
    (async () => {
      try {
        // if (userid) {

        setIsRecommendLoading(true);
        const res = await getRecomVideoList();
        setRecommendVideos(res.cards || []);
        // }
      } catch (e) {
        toast.error(e.message || 'request failed');
      } finally {
        setIsRecommendLoading(false);
      }
    })();
    return () => {
      // 
      clearInterval(videoStatusStRef.current);
      clearInterval(progressStRef.current);
      clearInterval(updateMyVideoListRef.current)
    }
  }, []);
  useEffect(() => {
    // console.log('upflag:', updateFlag);
    // 视频生成阶段取消，更新视频列表
    if (updateFlag) {
      updateMyVideoList();
      handleHasUpdated();
    }
  }, [updateFlag]);
  const removeCurLocalStorageQuestion = () => {
    LocalStorageUtil.removeLocalStorage(
      E_LocalStorageKey.userCurGenerateQuestionId,
    );
    LocalStorageUtil.removeLocalStorage(
      E_LocalStorageKey.userCurGenerateQuestionContent,
    );
    LocalStorageUtil.removeLocalStorage(
      E_LocalStorageKey.userCurGenerateQuestionPicUrl,
    );
  };
  // 获取用户的下一个问题
  const checkNextQuestion = () => {
    const questions = getQuestionListFromLocal();
    const curQuestionId = LocalStorageUtil.getLocalStorage(
      E_LocalStorageKey.userCurGenerateQuestionId,
    );
    if (questions.length && !curQuestionId) {
      const question = questions[0];
      console.log('submitquestion', question);
      if (question.question.trim() || question.url) {
        submitAnalyze(question.question, question.url);
        setQuestionListToLocal(questions.slice(1));
      } else {
        (window.__bl as any) &&
          window.__bl.error(new Error(JSON.stringify(questions)), {
            filename: 'homepage.tsx',
            lineno: 383,
            colno: 15,
          });
        setQuestionListToLocal(questions.slice(1));
        checkNextQuestion();
        toast.info('question or image is blank');
      }
    }
    updateLocalWaitQuesListLen();
  };
  const fetchCurQuestionStatus = async (videoId: string) => {
    // console.log('start:');
    try {
      const videoStatusRes = await getVideoStatus(videoId);
      switch (videoStatusRes.card.status) {
        case 'init':
          setProgressType('init');
          break;
        case 'q_proc': {
          if (
            videoStatusRes.card.qproc_ts &&
            new Date().getTime() -
              new Date(videoStatusRes.card.qproc_ts * 1000).getTime() >=
              150000
          ) {
            setProgressType('qproc_2');
          } else {
            setProgressType('qproc_1');
          }
          break;
        }
        case 'q_succ': {
          clearInterval(videoStatusStRef.current);
          clearInterval(progressStRef.current);
          setProgressValue(100);
          if (
            videoStatusRes.question_list &&
            videoStatusRes.question_list.length > 1
          ) {
            setDetectedQuestions(
              videoStatusRes.question_list.map((servQ, idx) => ({
                id: `${videoStatusRes.video_id}_${idx}`,
                idx: idx + 1,
                text: servQ.question,
                hasImage: servQ.image ? true : false,
                imageUrl: servQ.image,
                fromvideo: videoStatusRes.video_id,
              })),
            );
            setQuestionImageUrl(picUrl);
            // setQuestionImageUrl(
            //   hasMathHomeworkQuestions ? mathHomeworkImage : undefined
            // );
            setShowMultiQuestionDialog(true);
            setDeleteQuestionDialogOpen(false);
          } else {
            toast.info('Success! Generating a video!');
            // handleQuestionStr('');
            // setUploadFile(null);
            // setPicUrl('');
            updateMyVideoList();
            removeCurLocalStorageQuestion();
            checkNextQuestion();
            // onGenerate(videoStatusRes.card);
          }
          break;
        }
        case 'v_fail': {
          toast.error('Failed to recognize, please send again!');
        }
        case 'q_quit':
        case 'q_fail':
        case 'v_succ':
        case 'v_proc': {
          clearInterval(videoStatusStRef.current);
          clearInterval(progressStRef.current);
          setProgressValue(100);
          // progressStRef.current = window.setInterval(() => {
          //   setProgressValue((prev) => {
          //     const newValue = prev + 10;
          //     if (newValue >= 100) {
          //       return 100;
          //     }
          //     return newValue;
          //   });
          // }, 100);
          setCurtab('queue');
          updateMyVideoList();
          setDeleteQuestionDialogOpen(false);
          removeCurLocalStorageQuestion();
          checkNextQuestion();
          // handleQuestionStr('');
          // setUploadFile(null);
          // setPicUrl('');
          break;
        }
      }
    } catch (e) {
      // 出错
      clearInterval(videoStatusStRef.current);
      // setIsAnalyzing(false);
      // setProgressValue(0)
      clearInterval(progressStRef.current);
      setProgressValue(100);
      // progressStRef.current = window.setInterval(() => {
      //   setProgressValue((prev) => {
      //     const newValue = prev + 10;
      //     if (newValue >= 100) {
      //       return 100;
      //     }
      //     return newValue;
      //   });
      // }, 100);
      // LocalStorageUtil.removeLocalStorage(
      //   E_LocalStorageKey.userCurGenerateQuestionId,
      // );
      // LocalStorageUtil.removeLocalStorage(
      //   E_LocalStorageKey.userCurGenerateQuestionPicUrl,
      // );
      // LocalStorageUtil.removeLocalStorage(
      //   E_LocalStorageKey.userCurGenerateQuestionContent,
      // );
      removeCurLocalStorageQuestion();
      // handleQuestionStr('');
      // setUploadFile(null);
      // setPicUrl('');
      checkNextQuestion();
      toast.error(e.message || 'error, please retry');
    }
  };
  // 定时刷新问题状态步骤2-定时查询接口状态
  const refreshCurQuestionStatus = (videoId: string) => {
    clearInterval(videoStatusStRef.current);
    // 轮询查看生成状态
    videoStatusStRef.current = window.setInterval(async () => {
      // console.log('start:');
      try {
        const videoStatusRes = await getVideoStatus(videoId);
        switch (videoStatusRes.card.status) {
          case 'init':
            setProgressType('init');
            break;
          case 'q_proc': {
            if (
              videoStatusRes.card.qproc_ts &&
              new Date().getTime() -
                new Date(videoStatusRes.card.qproc_ts * 1000).getTime() >=
                150000
            ) {
              setProgressType('qproc_2');
            } else {
              setProgressType('qproc_1');
            }
            break;
          }
          case 'q_succ': {
            clearInterval(videoStatusStRef.current);
            clearInterval(progressStRef.current);
            setProgressValue(100);
            if (
              videoStatusRes.question_list &&
              videoStatusRes.question_list.length > 1
            ) {
              setDetectedQuestions(
                videoStatusRes.question_list.map((servQ, idx) => ({
                  id: `${videoStatusRes.video_id}_${idx}`,
                  idx: idx + 1,
                  text: servQ.question,
                  hasImage: servQ.image ? true : false,
                  imageUrl: servQ.image,
                  fromvideo: videoStatusRes.video_id,
                })),
              );
              setQuestionImageUrl(picUrl);
              // setQuestionImageUrl(
              //   hasMathHomeworkQuestions ? mathHomeworkImage : undefined
              // );
              setShowMultiQuestionDialog(true);
              setDeleteQuestionDialogOpen(false);
            } else {
              toast.info('Success! Generating a learning video!');
              // handleQuestionStr('');
              // setUploadFile(null);
              // setPicUrl('');
              updateMyVideoList();
              removeCurLocalStorageQuestion();
              checkNextQuestion();
              // onGenerate(videoStatusRes.card);
            }
            break;
          }
          case 'v_fail': {
            toast.error('Failed to recognize, please send again!');
          }
          case 'q_quit':
          case 'q_fail':
          case 'v_succ':
          case 'v_proc': {
            clearInterval(videoStatusStRef.current);
            clearInterval(progressStRef.current);
            setProgressValue(100);
            // progressStRef.current = window.setInterval(() => {
            //   setProgressValue((prev) => {
            //     const newValue = prev + 10;
            //     if (newValue >= 100) {
            //       return 100;
            //     }
            //     return newValue;
            //   });
            // }, 100);
            setCurtab('queue');
            updateMyVideoList();
            setDeleteQuestionDialogOpen(false);
            removeCurLocalStorageQuestion();
            checkNextQuestion();
            // handleQuestionStr('');
            // setUploadFile(null);
            // setPicUrl('');
            break;
          }
        }
      } catch (e) {
        // 出错
        clearInterval(videoStatusStRef.current);
        // setIsAnalyzing(false);
        // setProgressValue(0)
        clearInterval(progressStRef.current);
        setProgressValue(100);
        // progressStRef.current = window.setInterval(() => {
        //   setProgressValue((prev) => {
        //     const newValue = prev + 10;
        //     if (newValue >= 100) {
        //       return 100;
        //     }
        //     return newValue;
        //   });
        // }, 100);
        // LocalStorageUtil.removeLocalStorage(
        //   E_LocalStorageKey.userCurGenerateQuestionId,
        // );
        // LocalStorageUtil.removeLocalStorage(
        //   E_LocalStorageKey.userCurGenerateQuestionPicUrl,
        // );
        // LocalStorageUtil.removeLocalStorage(
        //   E_LocalStorageKey.userCurGenerateQuestionContent,
        // );
        removeCurLocalStorageQuestion();
        // handleQuestionStr('');
        // setUploadFile(null);
        // setPicUrl('');
        checkNextQuestion();
        toast.error(e.message || 'error, please retry');
      }
    }, 5000);
  };

  // 定时刷新问题状态步骤1-初始化一些状态
  const handleUserInputQuestionStatus = (
    videoId: string,
    remotePicUrl: string,
  ) => {
    LocalStorageUtil.setLocalStorage(
      E_LocalStorageKey.userCurGenerateQuestionId,
      videoId,
    );
    // LocalStorageUtil.setLocalStorage(
    //   E_LocalStorageKey.userCurGenerateQuestionContent,
    //   question,
    // );
    LocalStorageUtil.setLocalStorage(
      E_LocalStorageKey.userCurGenerateQuestionPicUrl,
      remotePicUrl,
    );
    // setIsAnalyzing(true);
    setProgressValue(1);
    setProgressType('init');
    // Update progress value smoothly
    clearInterval(progressStRef.current);
    progressStRef.current = window.setInterval(() => {
      setProgressValue((prev) => {
        const newValue = prev + (remotePicUrl ? 8 / 200 : 8);
        if (newValue >= 80) {
          return 80;
        }
        return newValue;
      });
    }, 100);
    // handleQuestionStr('');
    // setUploadFile(null);
    // setPicUrl('');
    // setQuestion(''); // Clear input after generating
    refreshCurQuestionStatus(videoId);
  };
  // 提交问题
  const submitAnalyze = async (ques: string, fileUrl: string) => {
    try {
      setIsSubmitQuestion(true);
      const isPdf = getFileTypeByFileName(fileUrl) === 'pdf';
      console.log('submit:', fileUrl, isPdf);
      const anaRes = await analyzeUserInput(
        ques,
        isPdf ? null : fileUrl,
        isPdf ? fileUrl : null,
      );
      if (anaRes.video_id) {
        handleUserInputQuestionStatus(anaRes.video_id, fileUrl);
        // LocalStorageUtil.setLocalStorage(
        //   E_LocalStorageKey.userCurGenerateQuestionId,
        //   anaRes.video_id,
        // );
      } else {
        toast.error('generate fail');
      }
      setIsSubmitQuestion(false);
    } catch (e) {
      setIsSubmitQuestion(false);
      toast.error(e.message || 'generate fail');
    }
  };

  const updateLocalWaitQuesListLen = () => {
    const questions = getQuestionListFromLocal();
    setWaitLen(questions.length);
  };
  const handleCancelCurQuestion = debounce(
    async () => {
      try {
        const videoId = LocalStorageUtil.getLocalStorage(
          E_LocalStorageKey.userCurGenerateQuestionId,
        );
        const picUrl = LocalStorageUtil.getLocalStorage(
          E_LocalStorageKey.userCurGenerateQuestionPicUrl,
        );
        if (videoId) {
          // 取消分题，直接变为q_quit
          await cancelSolve(videoId);
          // 立刻更新状态
          // refreshCurQuestionStatus(videoId);
          fetchCurQuestionStatus(videoId);
        } else {
          toast.info('Question not found');
        }
      } catch (e) {
        toast.error(e.message || 'request fail');
      }
    },
    500,
    {
      leading: false,
      trailing: true,
    },
  );
  const clearUserInput = () => {
    handleQuestionStr('');
    setUploadFile(null);
    setPicUrl('');
    setUploadedFileName('');
  };
  const handleSubmitQuestion = debounce(
    async () => {
      // Check if user is logged in
      if (!isLoggedIn) {
        onShowLogin();
        return;
      }
      console.log(question, picUrl, uploadFile);
      if (!((question.trim() && question.trim().length >= 3) || picUrl)) {
        toast.error('Please enter a valid question.');
        return;
      }
      const waitQue = getQuestionListFromLocal();
      if (waitQue.length >= 4) {
        toast.info(
          'The queue is full right now (5 tasks). Please try again in a moment.',
        );
        return;
      }
      try {
        // let fileUrl = await handleUploadFile(uploadFile);
        console.log('fileurl', picUrl);
        const waitQue = getQuestionListFromLocal();
        if (waitQue.length >= 4) {
          toast.info(
            'The queue is full right now (5 tasks). Please try again in a moment.',
          );
        } else if (picUrl || question.trim()) {
          setQuestionListToLocal(
            waitQue.concat([
              {
                url: picUrl,
                question: question,
              },
            ]),
          );
        } else {
          toast.info('question or pic is blank');
        }
        // 清除用户输入
        clearUserInput();
        checkNextQuestion();
        // submitAnalyze(question, fileUrl);
      } catch (e) {
        toast.error(e.message || 'generate request fail');
      }
    },
    500,
    { leading: false, trailing: true },
  );
  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    handleDataTransfer(e.clipboardData);

    // if (e.clipboardData.types != null) {
    //   for (var i = 0; i < e.clipboardData.types.length; i++) {
    //     console.log('... types[' + i + '] = ' + e.clipboardData.types[i]);
    //   }
    // }

    // // Print each item's "kind" and "type"
    // if (e.clipboardData.items != null) {
    //   for (var i = 0; i < e.clipboardData.items.length; i++) {
    //     console.log(
    //       '... items[' +
    //         i +
    //         '].kind = ' +
    //         e.clipboardData.items[i].kind +
    //         ' ; type = ' +
    //         e.clipboardData.items[i].type,
    //     );
    //   }
    // }
  };
  const handleDrop = (e: React.DragEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    handleDataTransfer(e.dataTransfer);
  };
  const handleDataTransfer = (dtransf: DataTransfer) => {
    if (!isLoggedIn) {
      onShowLogin();
      return;
    }
    console.log(dtransf.files, dtransf.items);
    const items = dtransf.items;
    if (dtransf.files && dtransf.files.length) {
      // 默认先只选择第一个
      const file = dtransf.files[0];
      // 不允许多个文件
      if (dtransf.files.length > 1) {
        toast.error('Multiple files detected. Please upload one file only.');
      } else {
        const filetype = getFileTypeByFileName(file.name || '');
        if (filetype === 'unknown') {
          toast.error('Unsupported file format. Please upload Image or PDF.');
          return;
        }
        if (file.size > 30 * 1024 * 1024) {
          toast.error('File is too large (Max 30MB)');
          return;
        }
        setUploadFile(file);
        handleUploadFile(file);
      }
    } else if (items.length) {
      let strItem: DataTransferItem | null = null;
      for (let i = 0; i < items.length; i++) {
        console.log(i, 'items[]:', items[i]);
        // 走不到了，上面已经处理
        if (items[i].kind === 'file') {
          // 不允许多个文件
          // if (items.length > 1) {
          //   toast.error(
          //     'Multiple files detected. Please upload one file only.',
          //   );
          // } else {
          //   setUploadFile(item.getAsFile());
          //   // handleUploadFile(item.getAsFile());
          // }
        } else if (
          items[i].kind === 'string' &&
          items[i].type.includes('text/plain')
        ) {
          strItem = items[i];
        }
      }
      if (strItem) {
        strItem.getAsString((s) => {
          // 将复制字符串放到光标位置
          const selectionStart = inputRef.current.selectionStart;
          const selectionEnd = inputRef.current.selectionEnd;
          const lastStrLeft = questionRef.current.slice(0, selectionStart);
          const lastStrRight = questionRef.current.slice(
            selectionEnd,
            questionRef.current.length,
          );
          handleQuestionStr(`${lastStrLeft}${s}${lastStrRight}`);
          const st = setTimeout(() => {
            clearTimeout(st);
            inputRef.current.setSelectionRange(
              selectionStart + s.length,
              selectionStart + s.length,
            );
          }, 30);
        });
      }
    }
  };
  const handleUploadFile = async (file: File) => {
    // console.log(file);
    if (!file) {
      toast.info('file not found');
      setUploadFile(null);
      setPicUrl('');
      (window.__bl as any) &&
        window.__bl.error(new Error('upload file null'), {
          filename: 'homepage.tsx',
          lineno: 882,
          colno: 13,
        });
      return;
    }
    (window.__bl as any) &&
      window.__bl.error(new Error(file.name || ''), {
        filename: 'homepage.tsx',
        lineno: 890,
        colno: 15,
      });
    // Check file size (30MB = 30 * 1024 * 1024 bytes)
    if (file.size > 30 * 1024 * 1024) {
      toast.error('File is too large (Max 30MB)');
      setUploadFile(null);
      setPicUrl('');
      (window.__bl as any) &&
        window.__bl.error(new Error('File is too large (Max 30MB)'), {
          filename: 'homepage.tsx',
          lineno: 899,
          colno: 15,
        });
      return;
    }
    if (!isLoggedIn) {
      onShowLogin();
      return;
    }

    try {
      // console.log(fileOptions.file )
      const fileContent = file;
      setIsUploading(true);
      const filetype = getFileTypeByFileName(fileContent.name || '');
      if (filetype === 'unknown') {
        toast.error('Unsupported file format. Please upload Image or PDF.');
        setIsUploading(false);
        setUploadFile(null);
        setPicUrl('');
        (window.__bl as any) &&
          window.__bl.error(
            new Error('Unsupported file format. Please upload Image or PDF.'),
            {
              filename: 'homepage.tsx',
              lineno: 916,
              colno: 15,
            },
          );
      }
      const contentType =
        filetype === 'pdf' ? 'application/pdf' : `image/${filetype}`;
      const signInfo = await getImgUploadSignInfo(contentType, filetype);
      // console.log(signInfo);
      if (signInfo && signInfo.url) {
        (window.__bl as any) &&
          window.__bl.error(new Error(signInfo.url || ''), {
            filename: 'homepage.tsx',
            lineno: 927,
            colno: 13,
          });
        await fetch(signInfo.url, {
          method: 'PUT', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'omit', // include, *same-origin, omit
          headers: { 'Content-Type': contentType },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: file, // body data type must match "Content-Type" header
        });
      }
      // console.log(signInfo);
      setIsUploading(false);
      const imgurlIndex = signInfo.url.indexOf('?');
      // For PDF, we might want to keep the file object to display name if needed,
      // but current logic sets uploadFile to null here.
      // We will rely on picUrl to determine if something is uploaded.
      // However, for PDF display we need the filename or we need to handle it.
      // The current logic sets setUploadFile(null) which might clear the preview if it depends on uploadFile.
      // Let's keep uploadFile in state if it is PDF to show name, or handle it differently.
      // Actually, looking at original code: setUploadFile(null); setPicUrl(...);
      // I will follow the pattern but maybe I need to store the type or filename if I want to display "filename.pdf".

      // If it is a PDF, we won't have a thumbnail from the URL immediately unless we generate it.
      // For now, we use the URL.
      // setUploadFile(null);
      setUploadedFileName(file.name);
      setPicUrl(signInfo.url.slice(0, imgurlIndex));
    } catch (e) {
      toast.error(e.message || 'request failed');
      setIsUploading(false);
      setUploadFile(null);
      setPicUrl('');
      (window.__bl as any) &&
        window.__bl.error(e, {
          filename: 'homepage.tsx',
          lineno: 965,
          colno: 15,
        });
    }
  };
  // const handleUploadFile = async (file: File) => {
  //   // console.log(file);
  //   if (!file) {
  //     (window.__bl as any) &&
  //       window.__bl.error(new Error('upload file null'), {
  //         filename: 'homepage.tsx',
  //         lineno: 882,
  //         colno: 13,
  //       });
  //     setPicUrl('');
  //     return '';
  //   }
  //   (window.__bl as any) &&
  //     window.__bl.error(new Error(file.name || ''), {
  //       filename: 'homepage.tsx',
  //       lineno: 890,
  //       colno: 15,
  //     });
  //   // Check file size (30MB = 30 * 1024 * 1024 bytes)
  //   if (file.size > 30 * 1024 * 1024) {
  //     toast.error('File is too large (Max 30MB)');
  //     setUploadFile(null);
  //     (window.__bl as any) &&
  //       window.__bl.error(new Error('File is too large (Max 30MB)'), {
  //         filename: 'homepage.tsx',
  //         lineno: 899,
  //         colno: 15,
  //       });
  //     throw new Error('File is too large (Max 30MB)');
  //   }

  //   try {
  //     // console.log(fileOptions.file )
  //     const fileContent = file;
  //     setIsUploading(true);
  //     const filetype = getFileTypeByFileName(fileContent.name || '');
  //     if (filetype === 'unknown') {
  //       toast.error('Unsupported file format. Please upload Image or PDF.');
  //       setIsUploading(false);
  //       setUploadFile(null);
  //       (window.__bl as any) &&
  //         window.__bl.error(
  //           new Error('Unsupported file format. Please upload Image or PDF.'),
  //           {
  //             filename: 'homepage.tsx',
  //             lineno: 916,
  //             colno: 15,
  //           },
  //         );
  //       throw new Error('Unsupported file format. Please upload Image or PDF.');
  //     }
  //     const contentType =
  //       filetype === 'pdf' ? 'application/pdf' : `image/${filetype}`;
  //     const signInfo = await getImgUploadSignInfo(contentType, filetype);
  //     // console.log(signInfo);
  //     if (signInfo && signInfo.url) {
  //       (window.__bl as any) &&
  //         window.__bl.error(new Error(signInfo.url || ''), {
  //           filename: 'homepage.tsx',
  //           lineno: 927,
  //           colno: 13,
  //         });
  //       await fetch(signInfo.url, {
  //         method: 'PUT', // *GET, POST, PUT, DELETE, etc.
  //         mode: 'cors', // no-cors, *cors, same-origin
  //         cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
  //         credentials: 'omit', // include, *same-origin, omit
  //         headers: { 'Content-Type': contentType },
  //         redirect: 'follow', // manual, *follow, error
  //         referrerPolicy: 'origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  //         body: file, // body data type must match "Content-Type" header
  //       });
  //     }
  //     // console.log(signInfo);
  //     setIsUploading(false);
  //     const imgurlIndex = signInfo.url.indexOf('?');
  //     // For PDF, we might want to keep the file object to display name if needed,
  //     // but current logic sets uploadFile to null here.
  //     // We will rely on picUrl to determine if something is uploaded.
  //     // However, for PDF display we need the filename or we need to handle it.
  //     // The current logic sets setUploadFile(null) which might clear the preview if it depends on uploadFile.
  //     // Let's keep uploadFile in state if it is PDF to show name, or handle it differently.
  //     // Actually, looking at original code: setUploadFile(null); setPicUrl(...);
  //     // I will follow the pattern but maybe I need to store the type or filename if I want to display "filename.pdf".

  //     // If it is a PDF, we won't have a thumbnail from the URL immediately unless we generate it.
  //     // For now, we use the URL.
  //     setUploadFile(null);
  //     setUploadedFileName(file.name);
  //     setPicUrl(signInfo.url.slice(0, imgurlIndex));
  //     return signInfo.url.slice(0, imgurlIndex);
  //   } catch (e) {
  //     toast.error(e.message || 'request failed');
  //     setIsUploading(false);
  //     (window.__bl as any) &&
  //       window.__bl.error(e, {
  //         filename: 'homepage.tsx',
  //         lineno: 965,
  //         colno: 15,
  //       });
  //     throw new Error(e.message || 'request failed');
  //   }
  // };

  const handleMultiQuestionGenerate = async (
    selectedQuestions: Array<IQuestion>,
  ) => {
    for (let qs of selectedQuestions) {
      try {
        const res = await analyzeUserInput(
          qs.text,
          qs.imageUrl || '',
          null,
          qs.fromvideo,
        );
        handleQuestionStr('');
        setPicUrl('');
        setUploadFile(null);
        removeCurLocalStorageQuestion();
        checkNextQuestion();
      } catch (e) {
        console.log(e);
      }
    }
    updateMyVideoList();
    toast.success(`Generating ${selectedQuestions.length} videos!`);
  };

  const handleShare = (videoId: string) => {
    const url = `${location.protocol}//${location.host}/#/video/${videoId}`;
    setShareUrl(url);
    setShareDialogOpen(true);
    // setCopied(false);
  };

  const handleDeleteClick = (videoId: string) => {
    setVideoToDelete(videoId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      if (videoToDelete) {
        // onDeleteVideo(videoToDelete);
        const res = await deleteMyVideo(videoToDelete);
        updateMyVideoList();
        toast.success('Video deleted');
        setVideoToDelete(null);
      }
      setDeleteDialogOpen(false);
    } catch (e) {
      toast.error('Video delete fail');
    }
  };

  // 定时循环更新视频列表
  const updateMyVideoList = async () => {
    // console.log(userid, updateFlag);
    const request = async () => {
      try {
        const res = await getMyVideoList();
        const newCards = res.cards || [];
        const isGeneratingVideo = newCards.find(
          (item) => item.status == 'v_proc' || item.status == 'q_proc',
        );
        // 检测新增的视频卡片（分题完成后新生成的）
        // const existingIds = new Set(myVideoList.map((v) => v.video_id));
        // const newIds = newCards
        //   .filter((card) => !existingIds.has(card.video_id))
        //   .map((card) => card.video_id);

        // if (newIds.length > 0) {
        //   setNewVideoIds((prev) => new Set([...prev, ...newIds]));
        //   // 动画结束后清除标记
        //   setTimeout(() => {
        //     setNewVideoIds((prev) => {
        //       const updated = new Set(prev);
        //       newIds.forEach((id) => updated.delete(id));
        //       return updated;
        //     });
        //   }, 600); // 动画持续时间 + 缓冲
        // }

        setMyVideoList(res.cards || []);
        if (!isGeneratingVideo) {
          clearInterval(updateMyVideoListRef.current);
        }
        return newCards;
      } catch (e) {
        clearInterval(updateMyVideoListRef.current);
        toast.error(e.message || 'request fail');
      }
    };
    const animationNewCards = await request();
    const existingIds = new Set(myVideoList.map((v) => v.video_id));
    const newIds = animationNewCards
      .filter((card) => !existingIds.has(card.video_id))
      .map((card) => card.video_id);

    if (newIds.length > 0) {
      setNewVideoIds((prev) => new Set([...prev, ...newIds]));
      // 动画结束后清除标记
      setTimeout(() => {
        setNewVideoIds((prev) => {
          const updated = new Set(prev);
          newIds.forEach((id) => updated.delete(id));
          return updated;
        });
      }, 600); // 动画持续时间 + 缓冲
    }
    clearInterval(updateMyVideoListRef.current);
    updateMyVideoListRef.current = window.setInterval(request, 5000);
  };
  // const filterMyVideoList = myVideoList.filter(
  //   (item) => !!['v_proc', 'v_succ', 'v_fail', 'q_fail'].includes(item.status),
  // );
  const isVProcList =
    myVideoList.filter(
      (item) => item.status == 'v_proc' || item.status == 'q_proc',
    ) || [];

  const isFinVideoList =
    myVideoList.filter(
      (item) => item.status != 'v_proc' && item.status != 'q_proc',
    ) || [];

  // explore 部分
  const homeScrollAreaRef = useRef<HTMLDivElement>(null);
  const [isExploreLoading, setIsExploreLoading] = useState(false);
  const isExploreLoadingRef = useRef<boolean>(false);
  const lastRef = useRef<string>('');
  const [last, setLast] = useState<string>('');
  const pageNumRef = useRef<number>(0);
  const [pageNum, setPageNum] = useState(0);

  const [exploreVideoList, setExploreVideoList] = useState<VideoCard[]>([]);
  const fetchExploreList = async (ref?: string) => {
    if (isExploreLoadingRef.current) {
      return;
    }
    if (pageNumRef.current >= 4) {
      return;
    }
    setIsExploreLoading(true);
    isExploreLoadingRef.current = true;

    // if (userid) {
    try {
      console.log('isfist:', ref, lastRef.current);
      pageNumRef.current += 1;
      setPageNum(pageNumRef.current);
      const res = await getExporeList('popular', '', ref ? ref : void 0);
      if (ref) {
        setExploreVideoList((prev) => prev.concat(res.cards || []));
      } else {
        setExploreVideoList(res.cards || []);
      }
      console.log(res.ref_id);
      setLast(res.ref_id);
      if (res.ref_id) {
        lastRef.current = res.ref_id;
      }
    } catch (e) {
      toast.error(e.message || 'request fail');
    } finally {
      setIsExploreLoading(false);
      isExploreLoadingRef.current = false;
    }
    // }
  };
  const updateList = (e) => {
    try {
      console.log(
        homeScrollAreaRef.current.scrollTop,
        homeScrollAreaRef.current.clientHeight,
        homeScrollAreaRef.current.scrollHeight,
      );
      if (
        homeScrollAreaRef.current.scrollTop +
          homeScrollAreaRef.current.clientHeight >=
        homeScrollAreaRef.current.scrollHeight
      ) {
        fetchExploreList(lastRef.current);
      }
    } catch (e) {
      toast.error(e.message || 'get history error');
    }
  };
  useEffect(() => {
    fetchExploreList();
    setTimeout(() => {
      // console.log(homeScrollAreaRef.current);
      if (homeScrollAreaRef.current) {
        homeScrollAreaRef.current.addEventListener('scroll', updateList);
      }
    }, 50);
    return () => {
      if (homeScrollAreaRef.current) {
        homeScrollAreaRef.current.removeEventListener('scroll', updateList);
      }
    };
  }, []);

  return (
    <>
      {/* <FloatingDecorations /> */}
      {waitLen || isAnalyzing ? (
        <div className="fixed z-20 bottom-6 left-[50%] translate-x-[-50%] transform-gpu py-3 px-4 border border-solid border-[#0000001A] bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,28,78,0.2)]">
          <div className="text-black text-xs font-medium">
            {progressMap[progressType]} (1/{waitLen + 1})...
          </div>
          <div className="mt-1.5 relative w-[225px] h-1.5 rounded-full bg-[#f5f5f5]">
            <div
              className="absolute left-0 top-0 h-1.5 rounded-full bg-linear-to-r from-[#FFa12e] to-[#ffe75c]"
              style={{
                width: `${progressValue}%`,
              }}
            ></div>
          </div>
          <button
            onClick={() => {
              setDeleteQuestionDialogOpen(true);
            }}
            className="absolute top-2 right-2 w-5 h-5 text-black rounded-full flex items-center justify-center transition-colors"
          >
            <X className="w-4.5 h-4.5" />
          </button>
        </div>
      ) : null}
      <div
        ref={homeScrollAreaRef}
        className={`main-bg w-full bg-no-repeat bg-size-[100%] h-screen box-border pt-[20vh] pb-12 px-6 md:px-10 relative z-10 overflow-y-scroll`}
      >
        <div className="max-w-[1296px] mx-auto">
          <div className="max-w-[700px] mx-auto">
            <div className="mb-11 text-[2rem] text-center leading-tight font-bold">
              <img className="inline-block h-10 mb-[13px]" src={iconXplai} />
              <div className="mb-3 text-[2rem] text-center leading-normal font-bold">
                The video engine for understanding
              </div>
            </div>
            <div className="space-y-4 animate-in fade-in slide-in-from-bottom-8 duration-700 delay-150">
              {/* Input Box */}
              <div
                className={`relative bg-[#fbfaf5] border border-[#00000033] shadow-[0px_8px_32px_0] shadow-[#001C4E33] rounded-3xl transition-all ${
                  isDragOver
                    ? 'border-primary ring-2 ring-primary/20 bg-blue-50/50'
                    : 'hover:border-black/20 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20'
                }`}
                onDragEnter={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsDragOver(true);
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsDragOver(true);
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                    setIsDragOver(false);
                  }
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsDragOver(false);
                  handleDataTransfer(e.dataTransfer);
                }}
              >
                {/* Drag Overlay */}
                {isDragOver && (
                  <div className="absolute inset-0 z-50 bg-white/80 backdrop-blur-xs rounded-3xl flex flex-col items-center justify-center border-2 border-dashed border-primary animate-in fade-in duration-200 pointer-events-none">
                    <Paperclip className="w-12 h-12 text-primary mb-2" />
                    <p className="text-lg font-medium text-primary">
                      Drop file here
                    </p>
                  </div>
                )}
                {/* Content wrapper inside the input box */}
                <div className="px-5 py-4 pb-14">
                  {/* Uploaded Image Preview - Inside input box */}
                  {(picUrl || (picSrc && uploadFile)) && (
                    <div className="mb-3 relative inline-block">
                      {uploadFile?.type === 'application/pdf' ||
                      uploadedFileName?.toLowerCase().endsWith('.pdf') ||
                      picUrl?.toLowerCase().includes('.pdf') ? (
                        <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-xl border border-black/10 max-w-[250px]">
                          <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center shrink-0">
                            <FileText className="w-5 h-5 text-red-500" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="text-sm font-medium truncate">
                              {uploadFile?.name ||
                                uploadedFileName ||
                                'Document.pdf'}
                            </div>
                            <div className="text-xs text-muted-foreground">
                              PDF Document
                            </div>
                          </div>
                        </div>
                      ) : (
                        <img
                          src={picUrl || picSrc}
                          alt="Uploaded"
                          className="max-w-[200px] max-h-32 rounded-xl border border-black/10"
                        />
                      )}

                      {isUploading ? (
                        <div className=" absolute left-0 top-0 w-full h-full flex items-center justify-center">
                          <CircularProgress
                            progress={90}
                            strokeWidth={3}
                            size={40}
                            animationDuration={5}
                            circleColor="#e6e4dc"
                            progressColor="#fff"
                          />
                        </div>
                      ) : picUrl ? (
                        <button
                          onClick={() => {
                            setPicUrl('');
                            setUploadFile(null);
                            // removeCurLocalStorageQuestion();
                          }}
                          className="absolute -top-2 -right-2 w-5 h-5 bg-black hover:bg-black/80 text-white rounded-full flex items-center justify-center transition-colors"
                        >
                          <X className="w-3 h-3" />
                        </button>
                      ) : (
                        <div className="absolute left-0 top-0 w-full h-full flex items-center justify-center">
                          <CircleAlert size={32} color="#FF2A2AA3" />
                        </div>
                      )}
                    </div>
                  )}

                  <Textarea
                    ref={inputRef}
                    onPaste={handlePaste}
                    // onDrop={handleDrop}
                    // onDragOver={(e) => {
                    //   e.preventDefault();
                    // }}
                    // onDragLeave={(e) => {
                    //   e.preventDefault();
                    // }}
                    value={question}
                    maxLength={1000}
                    onChange={(e) => {
                      markUserHasTyped();
                      handleQuestionStr(e.target.value);
                    }}
                    placeholder={typingPlaceholder}
                    className="min-h-20 border-0 p-0 resize-none focus-visible:ring-0 focus-visible:ring-offset-0 bg-transparent placeholder:text-gray-400"
                    onKeyDown={(e) => {
                      if (
                        ['enter'].includes(e.key.toLowerCase()) &&
                        e.ctrlKey
                      ) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (question || picUrl) {
                          handleSubmitQuestion();
                        } else {
                          toast.info('Please enter a valid question.');
                        }
                      }
                    }}
                  />
                </div>
                {/* Bottom controls - inside textarea */}
                {/* <div className="absolute bottom-4 left-0 right-0 flex items-center justify-between px-5">
                  <div className="flex items-center gap-2">
                    <label className="cursor-pointer flex items-center justify-center w-8 h-8">
                      <input
                        type="file"
                        accept="image/*,application/pdf"
                        className="hidden"
                        onChange={(e) => {
                          if (isUploading) {
                            toast.info('processing, please wait...');
                            return;
                          }
                          if (uploadFile) {
                            toast.error(
                              'You can only upload one image at a time',
                            );
                            e.target.value = '';
                            return;
                          }

                          const file = e.target.files?.[0];
                          if (file) {
                            setUploadFile(file);
                          } else {
                            toast.error('upload failed, please retry');
                          }
                        }}
                      />
                      <ImageIcon className="w-4 h-4 text-black transition-colors cursor-pointer" />
                    </label>

                    <button
                      onClick={handleShuffle}
                      className="h-8 px-[13px] flex items-center gap-2 rounded-[12px] border border-[#ffe75c] hover:bg-[#ffe75c] transition-colors"
                    >
                      <Shuffle className="w-4 h-4 text-[#302f2b]" />
                      <span
                        className="text-sm font-medium text-black"
                        style={{ fontFamily: "'Alibaba PuHuiTi', sans-serif" }}
                      >
                        Shuffle
                      </span>
                    </button>
                  </div>
                  {question ? (
                    <div className="font-normal text-xs text-[#00000033]">
                      Ctrl + Enter to send!
                    </div>
                  ) : null}
                  <div className="flex items-center gap-1.5">
                    <div className="text-sm font-medium text-gray-400">
                      <span className={question.length ? 'text-gray-500' : ''}>
                        {question.length}
                      </span>
                      /1000
                    </div>
                    {isUploading ? (
                      <div className="w-15 h-10 bg-[#f5f5f5] rounded-full flex justify-center items-center">
                        <Spinner
                          loading={isUploading}
                          size="2"
                          className="mr-2"
                        />
                      </div>
                    ) : (
                      <div>
                        {!question.trim() && !uploadFile && !picUrl ? (
                          <img className="w-[60px]" src={SubmitBtnDiabled} />
                        ) : (
                          <img
                            className="w-[60px]"
                            src={SubmitBtn}
                            onClick={handleSubmitQuestion}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div> */}

                <div className="absolute bottom-4 left-0 right-0 flex items-center justify-between px-4">
                  <div className="flex items-center gap-2">
                    <div className="flex items-center justify-center w-8 h-8 bg-[#e6e4dc] rounded-full shrink-0">
                      <label className="cursor-pointer flex items-center justify-center w-full h-full">
                        <input
                          type="file"
                          accept="image/png, image/jpeg,application/pdf"
                          className="hidden"
                          onChange={(e) => {
                            if (!isLoggedIn) {
                              e.target.value = ''; // Reset the input
                              onShowLogin();
                              return;
                            }
                            if (isUploading) {
                              e.target.value = ''; // Reset the input
                              toast.info('processing, please wait...');
                              return;
                            }
                            // Check if an image is already uploaded
                            if (uploadFile) {
                              toast.error(
                                'You can only upload one file at a time',
                              );
                              e.target.value = ''; // Reset the input
                              return;
                            }

                            const file = e.target.files?.[0];
                            if (file) {
                              const filetype = getFileTypeByFileName(
                                file.name || '',
                              );
                              if (filetype === 'unknown') {
                                toast.error(
                                  'Unsupported file format. Please upload Image or PDF.',
                                );
                                e.target.value = '';
                                return;
                              }
                              if (file.size > 30 * 1024 * 1024) {
                                toast.error('File is too large (Max 30MB)');
                                e.target.value = '';
                                return;
                              }
                              setUploadFile(file);
                              e.target.value = '';
                              handleUploadFile(file);
                            } else {
                              toast.error('upload failed, please retry');
                            }
                          }}
                        />
                        <Paperclip className="w-4 h-4 text-black transition-colors cursor-pointer" />
                      </label>
                    </div>

                    {/* Shuffle Button */}
                    <button
                      onClick={handleShuffle}
                      className="h-8 px-[13px] flex items-center gap-2 rounded-[12px] border border-primary hover:bg-[#e6e4dc] transition-colors shrink-0"
                    >
                      <Shuffle className="w-4 h-4 text-[#302f2b]" />
                      <span
                        className="text-sm font-medium text-black"
                        style={{ fontFamily: "'Alibaba PuHuiTi', sans-serif" }}
                      >
                        Shuffle
                      </span>
                    </button>
                  </div>

                  {/* Centered Tip Text */}
                  {question ? (
                    <div className="absolute left-1/2 -translate-x-1/2 font-normal text-xs text-[rgba(0,0,0,0.2)]">
                      Ctrl + Enter to send!
                    </div>
                  ) : null}

                  <div className="flex items-center gap-4">
                    <div className="text-sm font-medium text-[rgba(0,0,0,0.1)]">
                      <span className={question.length ? 'text-gray-500' : ''}>
                        {question.length}
                      </span>
                      /1000
                    </div>

                    {isUploading ? (
                      <div className="w-[60px] h-10 bg-[#f5f5f5] rounded-full flex justify-center items-center shrink-0">
                        <Spinner loading={isUploading} size="2" />
                      </div>
                    ) : (
                      <div className="cursor-pointer shrink-0">
                        {!question.trim() && !picUrl ? (
                          <img
                            className="w-[60px] h-10 shrink-0"
                            src={SubmitBtnDiabled}
                          />
                        ) : (
                          <img
                            className="w-[60px] h-10 shrink-0"
                            src={SubmitBtn}
                            onClick={handleSubmitQuestion}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* New Feature Hint */}
                {/* <div className="absolute -bottom-12 left-0 right-0 flex justify-center pointer-events-none">
                  <button
                    onClick={() => {}}
                    className="pointer-events-auto flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50/50 border border-blue-100/50 text-blue-600 hover:bg-blue-50 hover:border-blue-200 transition-all text-base md:text-sm font-medium animate-in fade-in slide-in-from-top-4 duration-700 delay-300"
                  >
                    ✨ NEW: Generate Video from Financial PDFs
                  </button>
                </div> */}
              </div>
            </div>
          </div>

          {/* 候选提示词 */}
          <div className="mt-6">
            <CandidatePrompt onPromptClick={handleCandidatePromptClick} />
          </div>

          <div className="mt-10 w-full animate-in fade-in slide-in-from-bottom-8 duration-700 delay-300 bg-[#FCFBF7CC] border border-black/10 rounded-[24px]">
            <Tabs
              onValueChange={(v: 'my-videos' | 'queue' | 'example') => {
                setCurtab(v);
              }}
              value={curtab}
              key={isLoggedIn ? 'logged-in' : 'not-logged-in'}
              defaultValue={isLoggedIn ? 'my-videos' : 'example'}
              className="w-full gap-0"
            >
              <div className="flex items-center justify-between px-6 py-5">
                <TabsList className="bg-transparent border-0 p-0 gap-1 h-auto w-auto">
                  {isLoggedIn ? (
                    <TabsTrigger
                      value="my-videos"
                      className="rounded-xl px-3 py-2 text-xs font-medium text-[#9d9d9d] data-[state=active]:bg-white data-[state=active]:border-[#dcdde0] data-[state=active]:border data-[state=active]:text-black transition-all cursor-pointer shadow-none!"
                    >
                      My Videos
                    </TabsTrigger>
                  ) : null}
                  {isLoggedIn ? (
                    <div className=" relative">
                      <TabsTrigger
                        value="queue"
                        className="rounded-xl px-3 py-2 text-xs font-medium text-[#9d9d9d] data-[state=active]:bg-white data-[state=active]:border-[#dcdde0] data-[state=active]:border data-[state=active]:text-black transition-all cursor-pointer shadow-none!"
                      >
                        Queue
                      </TabsTrigger>
                      {isVProcList.length ? (
                        <div className=" absolute top-0 -right-1 rounded-full w-4 h-4 bg-[#f21919] flex items-center justify-center text-white text-[12px] font-semibold">
                          {isVProcList.length}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <TabsTrigger
                    value="example"
                    className="rounded-xl px-3 py-2 text-xs font-medium text-[#9d9d9d] data-[state=active]:bg-white data-[state=active]:border-[#dcdde0] data-[state=active]:border data-[state=active]:text-black transition-all cursor-pointer shadow-none!"
                  >
                    Examples
                  </TabsTrigger>
                </TabsList>

                <Button
                  onClick={() => {
                    if (curtab === 'example') {
                      onNavigateToExplore();
                    } else {
                      onNavigateToMyVideos();
                    }
                  }}
                  variant="ghost"
                  className="text-xs font-medium text-[#9d9d9d] hover:bg-transparent hover:text-black/70 px-0 h-auto gap-1"
                >
                  <span>View all</span>
                  <ArrowRight className="w-4 h-4" />
                </Button>
              </div>

              <div className="px-6 pb-5">
                <TabsContent value="my-videos" className="mt-0">
                  {isMyVideosLoading ? (
                    <div className="flex items-center justify-center py-20">
                      <Loader2 className="w-12 h-12 text-black animate-spin" />
                    </div>
                  ) : isFinVideoList.length > 0 ? (
                    <div className="overflow-x-auto w-full">
                      <div className="flex gap-4 pb-4 -mx-6 px-6">
                        {isFinVideoList.map((video, index) => (
                          <MyVideoCard
                            key={video.video_id}
                            video={video}
                            index={index}
                            subjectColorMap={mySubjectColors}
                            onVideoClick={onVideoClick}
                            onShare={handleShare}
                            onDelete={handleDeleteClick}
                            onCancelGenerate={(videoId) => {
                              onCancelGenerate(videoId);
                              toast.info('Video generation stopped');
                            }}
                            onReGenerate={
                              onReGenerate
                                ? (videoId) => {
                                    onReGenerate(videoId);
                                    toast.success('Retrying video generation');
                                  }
                                : undefined
                            }
                          />
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="py-12 text-center text-muted-foreground bg-[#FDFBF6] rounded-3xl border border-dashed border-black/10">
                      <p>
                        No videos yet. Ask a question to generate your first
                        video!
                      </p>
                    </div>
                  )}
                </TabsContent>
                <TabsContent value="queue" className="mt-0">
                  {
                    isMyVideosLoading ? (
                      <div className="flex items-center justify-center py-20">
                        <Loader2 className="w-12 h-12 text-black animate-spin" />
                      </div>
                    ) : isVProcList.length > 0 ? (
                      <div className="pb-6">
                        <div className="flex flex-wrap">
                          {isVProcList.map((video, index) => (
                            <MyVideoCard
                              key={video.video_id}
                              video={video}
                              index={index}
                              subjectColorMap={mySubjectColors}
                              onVideoClick={onVideoClick}
                              onShare={handleShare}
                              onDelete={handleDeleteClick}
                              onCancelGenerate={(videoId) => {
                                onCancelGenerate(videoId);
                                toast.info('Video generation stopped');
                              }}
                              onReGenerate={
                                onReGenerate
                                  ? (videoId) => {
                                      onReGenerate(videoId);
                                      toast.success(
                                        'Retrying video generation',
                                      );
                                    }
                                  : undefined
                              }
                            />
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="py-12 text-center text-muted-foreground bg-[#FDFBF6] rounded-3xl border border-dashed border-black/10">
                        <p>
                          No videos yet. Ask a question to generate your first
                          video!
                        </p>
                      </div>
                    )
                    // <RecommendedClipsGrid
                    //   videos={isVProcList}
                    //   onVideoClick={onVideoClick}
                    // />
                  }
                </TabsContent>

                <TabsContent value="example" className="mt-0">
                  {isRecommendLoading ? (
                    <div className="flex items-center justify-center py-20">
                      <Loader2 className="w-12 h-12 text-black animate-spin" />
                    </div>
                  ) : (
                    <RecommendedClipsGrid
                      videos={recommendVideos || []}
                      onVideoClick={onVideoClick}
                    />
                  )}
                </TabsContent>
              </div>
            </Tabs>
          </div>
          {/* explore */}
          <div>
            <h3 className="text-[32px] mt-8 mb-6 font-semibold">Explore</h3>
            <div className="w-full">
              {(exploreVideoList || []).length === 0 ? (
                <div className="text-center py-16 animate-in fade-in duration-500">
                  <div className="mb-4 flex justify-center">
                    <img
                      src="https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-11-10/312521f1-74a7-4d0d-b3e3-dd14dd7f9634/6edd4dcb-3619-4d12-bfa3-34f4ae2144b9.png"
                      alt="No videos"
                      style={{ width: '140px', height: '140px' }}
                    />
                  </div>
                  <h3 className="mb-2 text-black">No videos found</h3>
                  <p className="text-muted-foreground">
                    {'Start generating your first video explanation!'}
                  </p>
                </div>
              ) : (
                <>
                  <div className="flex items-center justify-start gap-4 flex-wrap video-list">
                    {(exploreVideoList || []).map((video, index) => {
                      const videoSubject = video.subject || 'Others';
                      const subjectColor = subjectColors[videoSubject]
                        ? subjectColors[videoSubject]
                        : subjectColors['Others'];
                      const calcVideo = videoCardToCommon(video);
                      return (
                        // <CommonVideoCard
                        //   key={`${video.video_id}_${index}_${video.video_url}`}
                        //   video={videoCardToCommon(video)}
                        //   index={index}
                        //   subjectColorMap={
                        //     subjectColors as Record<string, SubjectColor>
                        //   }
                        //   onVideoClick={onVideoClick}
                        // />
                        <Card
                          key={calcVideo.id}
                          onClick={() => onVideoClick(calcVideo.id)}
                          className="w-[310px] gap-2 overflow-hidden transition-all duration-300 cursor-pointer hover:bg-accent animate-in fade-in slide-in-from-bottom-4 border-none shadow-none"
                          style={{
                            animationDelay: `${index * 50}ms`,
                            border: 'none',
                            boxShadow: 'none',
                          }}
                        >
                          {/* Thumbnail */}
                          <div
                            className="relative aspect-video flex items-center justify-center overflow-hidden border"
                            style={{
                              background: `url(${calcVideo.cover_img || 'https://cdn.jumpstar.app/solve/ai_gen/20251201/9f2c75b4-6e7d-4380-9ca5-c88d066b5c1f.png'}) center center / 100% no-repeat`,
                              borderRadius: '12px',
                            }}
                          >
                            <PlayBtn />

                            {/* Duration */}
                            <div className="absolute bottom-2 right-2">
                              <div className="bg-black/30 text-white text-xs px-2 py-0.5 rounded">
                                {formatDuration(
                                  Math.floor(calcVideo.video_duration),
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Content */}
                          <div className="py-3 pt-0.5 flex flex-col h-[86px]">
                            {/* Subject Badge and Creation Time */}
                            <div className="flex items-center justify-between mb-2">
                              <Badge
                                className={`${subjectColor.bg} ${subjectColor.text} rounded-full px-3 py-0.5 border border-black/5`}
                              >
                                {videoSubject}
                              </Badge>
                              <span className="text-xs text-muted-foreground">
                                {formatTimeAgo(calcVideo.createdAt)}
                              </span>
                            </div>
                            {/* Title - always takes 2 lines space */}
                            <h4 className="mb-2 line-clamp-2 min-h-12">
                              <ReactMarkdown
                                remarkPlugins={[remarkMath]}
                                rehypePlugins={[rehypeKatex]}
                              >
                                {calcVideo.question}
                              </ReactMarkdown>
                            </h4>

                            <div className="grow"></div>
                          </div>
                        </Card>
                      );
                    })}
                  </div>
                  {last && pageNum < 4 && (
                    <div className="text-center mt-6 animate-in fade-in duration-500">
                      <Button
                        onClick={() => fetchExploreList(lastRef.current)}
                        variant="outline"
                        className="rounded-xl"
                      >
                        Load More
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* My Solve Clips */}
          {/* {myVideoList.length > 0 && (
            <div className="mt-20 animate-in fade-in slide-in-from-bottom-8 duration-700 delay-300">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="mb-1 text-xl font-alipuhui-b">
                    My Solve Clips
                  </h2>
                  <p className="text-sm text-muted-foreground">
                    View and manage your generated clips explanations
                  </p>
                </div>
                <Button
                  onClick={onNavigateToMyVideos}
                  variant="outline"
                  className="rounded-xl hover:bg-[#FFE75C]!"
                >
                  <span>View All</span>
                  <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </div>

              <div className="overflow-x-auto py-8">
                <div className="flex gap-4 min-w-max">
                  {myVideoList.map((video, index) => {
                    const isGenerating = video.status === 'v_proc';
                    const isComplete = video.status === 'v_succ';
                    const isFailed = video.status === 'v_fail';
                    const videoSubject = isComplete
                      ? video.subject || 'Others'
                      : 'Others';
                    const subjectColor = mySubjectColors[videoSubject]
                      ? mySubjectColors[videoSubject]
                      : mySubjectColors['Others'];
                    const hasWatchProgress =
                      video.watchProgress && video.watchProgress > 0;
                    return (
                      <Card
                        key={video.video_id}
                        onClick={() =>
                          !isGenerating &&
                          !isFailed &&
                          onVideoClick(video.video_id)
                        }
                        className={`w-[280px] overflow-hidden bg-[#fdfbf6] shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1),0px_4px_6px_-4px_rgba(0,0,0,0.1)] transition-all duration-300 shrink-0 rounded-3xl ${
                          !isGenerating && !isFailed
                            ? 'cursor-pointer hover:scale-105'
                            : 'cursor-default'
                        }`}
                        style={{ animationDelay: `${index * 100}ms` }}
                      >
                        <div
                          className={`relative aspect-video flex items-center justify-center overflow-hidden ${
                            isGenerating ? 'glass-loading-container' : ''
                          }`}
                          style={{
                            background: isGenerating
                              ? 'transparent'
                              : isFailed
                                ? `url('https://cdn.tiantiantiaosheng.com/dataupload/tool/2025-11-05/a58ee59c-0051-42c4-8ada-50b7d2f06838/f671992e-fe91-4e5c-aa5e-3cfb365b2853.png') center/cover`
                                : `url(${video.cover_img || 'https://cdn.jumpstar.app/solve/ai_gen/20251201/9f2c75b4-6e7d-4380-9ca5-c88d066b5c1f.png'}) center center / 100% no-repeat`,
                            borderRadius: '22px 22px 0px 0px',
                          }}
                        >
                          {isGenerating && (
                            <>
                              <div className="glass-blur"></div>
                              <div className="glass-gradient"></div>
                              <div className="glass-shimmer"></div>
                            </>
                          )}
                          {!isGenerating && !isFailed && (
                            <>
                              <PlayBtn />
                            </>
                          )}
                          {!isGenerating && !isFailed && (
                            <div className="absolute bottom-2 right-2">
                              <div className="bg-black/30 text-white text-xs px-2 py-0.5 rounded">
                                {formatDuration(
                                  Math.floor(video.video_duration),
                                )}
                              </div>
                            </div>
                          )}
                          {isComplete && (
                            <div className="absolute top-2 left-2">
                              <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    className="h-8 w-8 bg-white/95 hover:bg-white shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.1)] rounded-full"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <MoreVertical className="w-4 h-4" />
                                  </Button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent
                                  align="start"
                                  className="w-40 rounded-2xl"
                                >
                                  <DropdownMenuItem
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleShare(video.video_id);
                                    }}
                                  >
                                    <Share2 className="w-4 h-4 mr-2" />
                                    Share
                                  </DropdownMenuItem>
                                  <DropdownMenuItem
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteClick(video.video_id);
                                    }}
                                    className="text-red-600 focus:text-red-600"
                                  >
                                    <Trash2 className="w-4 h-4 mr-2" />
                                    Delete
                                  </DropdownMenuItem>
                                </DropdownMenuContent>
                              </DropdownMenu>
                            </div>
                          )}
                        </div>

                        <div className="p-3 pt-0.5 flex flex-col h-[140px]">
                          <div className="flex items-center justify-between mb-2">
                            {isGenerating ? (
                              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                                <Clock className="w-3.5 h-3.5" />
                                <span>
                                  {(() => {
                                    const elapsed = Math.floor(
                                      (Date.now() -
                                        (video.create_ts || 0) * 1000) /
                                        1000,
                                    );
                                    const totalSeconds = 10 * 60; // 10分钟
                                    const progressPercent = Math.min(
                                      Math.floor((elapsed / totalSeconds) * 90),
                                      90,
                                    );
                                    return `Generating ${progressPercent}%`;
                                  })()}
                                </span>
                              </div>
                            ) : (
                              <Badge
                                className={`${subjectColor.bg} ${subjectColor.text} rounded-full px-3 py-0.5 border border-black/5`}
                              >
                                {videoSubject}
                              </Badge>
                            )}
                            <span className="text-xs text-muted-foreground">
                              {formatTimeAgo(new Date(video.create_ts * 1000))}
                            </span>
                          </div>
                          <h4 className="mb-2 line-clamp-2 min-h-12 h-12">
                            <ReactMarkdown
                              remarkPlugins={[remarkMath]} // 解析数学公式
                              rehypePlugins={[rehypeKatex]} // 渲染数学公式
                            >
                              {video.title}
                            </ReactMarkdown>
                          </h4>
                          <div className="grow"></div>

                          {isGenerating && (
                            <div className="flex items-center gap-2">
                              <Button className="flex-1 rounded-2xl flex items-center justify-start gap-2 bg-[#302f2b] hover:bg-[#302f2b]/90 text-[#ffe75c] h-9">
                                <div className="bar-wave-home">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </div>
                                <span>Generating...</span>
                              </Button>
                              <Button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onCancelGenerate(video.video_id);
                                  toast.info('Video generation stopped');
                                }}
                                className="rounded-2xl flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-700 h-9 px-3"
                              >
                                <X className="w-4 h-4" />
                              </Button>
                            </div>
                          )}

                          {isFailed && (
                            <div className="flex items-center gap-2">
                              <Button
                                disabled
                                className="flex-1 rounded-2xl flex items-center justify-start gap-2 bg-[#f0f0f0] hover:bg-[#f0f0f0] text-black h-9 cursor-not-allowed"
                              >
                                <span>Generation failed</span>
                              </Button>
                              <Button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (onReGenerate) {
                                    onReGenerate(video.video_id);
                                    toast.success('Retrying video generation');
                                  }
                                }}
                                className="rounded-2xl flex items-center justify-center bg-[#302f2b] hover:bg-[#302f2b]/90 text-[#ffe75c] h-9 px-3"
                              >
                                <RefreshCw className="w-4 h-4" />
                              </Button>
                            </div>
                          )}

                          {isComplete && (
                            <Button
                              onClick={(e) => {
                                e.stopPropagation();
                                onVideoClick(video.video_id);
                              }}
                              className="w-full rounded-2xl flex items-center justify-start gap-2 bg-[#302f2b] hover:bg-[#302f2b]/90 text-[#ffe75c] h-9"
                            >
                              <Play className="w-4 h-4" />
                              <span>Ready to play</span>
                            </Button>
                          )}
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </div>
            </div>
          )} */}

          {/* Explore Popular Clips */}
          {/* <div className="mt-20 animate-in fade-in slide-in-from-bottom-8 duration-700 delay-500">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="mb-1 text-xl font-alipuhui-b">
                  Explore Popular Clips
                </h2>
                <p className="text-sm text-muted-foreground">
                  Discover and learn from clips created by the community
                </p>
              </div>
              <Button
                onClick={onNavigateToExplore}
                variant="outline"
                className="rounded-xl hover:bg-[#FFE75C]!"
              >
                <span>View All</span>
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </div>

            <RecommendedClipsGrid
              videos={recommendVideos || []}
              onVideoClick={onVideoClick}
            />
          </div> */}
        </div>

        {/* Multi-Question Dialog */}
        {showMultiQuestionDialog ? (
          <MultiQuestionDialog
            open={showMultiQuestionDialog}
            onClose={() => {
              console.log('close');
              clearInterval(progressStRef.current);
              setProgressValue(100);
              setDeleteQuestionDialogOpen(true);
            }}
            questions={detectedQuestions}
            onGenerate={(selectQs: IQuestion[]) => {
              setShowMultiQuestionDialog(false);
              handleMultiQuestionGenerate(selectQs);
            }}
            imageUrl={questionImageUrl || ''}
          />
        ) : null}

        {/* Share Dialog */}
        {shareDialogOpen && (
          <ShareDialog
            shareUrl={shareUrl}
            setShareDialogOpen={setShareDialogOpen}
            shareDialogOpen={shareDialogOpen}
          />
        )}
        <QuestionDeleteConfirmDialog
          showDeleteConfirmDialog={deleteQuestionDialogOpen}
          setShowDeleteConfirmDialog={setDeleteQuestionDialogOpen}
          handleConfirm={() => {
            setDeleteQuestionDialogOpen(false);
            setShowMultiQuestionDialog(false);
            handleCancelCurQuestion();
          }}
        />

        {/* Delete Confirmation Dialog */}
        <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
          <AlertDialogContent className="rounded-3xl">
            <AlertDialogHeader>
              <AlertDialogTitle>Are you sure?</AlertDialogTitle>
              <AlertDialogDescription>
                This action cannot be undone. This will permanently delete your
                video.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel className="rounded-full">
                Cancel
              </AlertDialogCancel>
              <AlertDialogAction
                onClick={handleDeleteConfirm}
                className="bg-red-600 hover:bg-red-700 text-white rounded-full"
              >
                Delete
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </>
  );
}
